import React, { FC, ReactNode } from "react";

import { Button, Props as ButtonProps } from "../Button";
import { Message, MessageProps } from "../Message";

export type ActionableMessageProps = {
  ctaContent?: ReactNode;
  ctaProps?: ButtonProps;
} & Omit<MessageProps, "img" | "children">;

export const ActionableMessage: FC<ActionableMessageProps> = ({
  heading,
  text,
  type,
  icon,
  orientation = "vertical",
  onClick,
  ctaContent,
  ctaProps,
  ...rest
}) => {
  return (
    <Message
      heading={heading}
      text={text}
      type={type}
      icon={icon}
      onClick={onClick}
      orientation={orientation}
      {...rest}
    >
      {(onClick || ctaProps) && ctaContent && (
        <Button
          block
          contentClassName="capitalize font-semibold text-base flex flex-row justify-between w-full"
          onClick={onClick}
          variant={Button.variant.PRIMARY}
          {...ctaProps}
        >
          {ctaContent}
        </Button>
      )}
    </Message>
  );
};
